// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FhDnN","close-wrapper":"_13UaT","user-select-code":"_1YTX5","cross-icon":"_2vErx","title":"_1oIk-","message":"_133Q3","news-link":"_2hnnq"};